import { Modal, Box, IconButton, InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import pickFile from "assets/setting/freepik--Folder--inject-63.png";

import { SettingContext } from "context/SettingContext";
import USPCard from "features/Setting/Product_USP_and_Gallery/USPCard";
import Button from "components/ui/Button";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";

import apiClient from "lib/api-client";
import config from "configs/config";
import { toast } from "react-toastify";
import { transformUspData } from "utils/transformdata";
import { useGetExcatDesign } from "features/Setting/Product_USP_and_Gallery/API/addBtnApi";

/* ---------------- styles ---------------- */

const modalTitleStyle = {
  color: "#8B8B8B",
  fontFamily: "Poppins, sans-serif",
  fontSize: "1.19vw",
  fontWeight: 500,
  letterSpacing: "0.41px",
};

const closeBtnStyle = {
  background: "none",
  border: "1px solid #8B8B8B",
  color: "#8B8B8B",
  cursor: "pointer",
  width: "32px",
  height: "32px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1),
    width: "100%",
  },
}));

/* ---------------- component ---------------- */

function SelectDesignModal({ open, isDetail, uspDetailData, setUspDetailData, setIsDetail, existingData, handleSaveParent }) {
  const { setAddModalOpen } = useContext(SettingContext);

  const [searchValue, setSearchValue] = useState("");
  const [designToFetch, setDesignToFetch] = useState("");
  const [showCard, setShowCard] = useState(false);
  const [selectedDesign, setSelectedDesign] = useState(null);

  /* ---------- API ---------- */
  const { data, isLoading } = useGetExcatDesign(designToFetch);

  // console.log("uspDetailData", uspDetailData);

  /* ---------- handlers ---------- */

  const handleCloseAddModal = () => {
    setAddModalOpen(false);
    setSearchValue("");
    setDesignToFetch("");
    setShowCard(false);
    setSelectedDesign(null);
  };

  const handleSearchInputChange = (e) => {
    setSearchValue(e.target.value);
    setShowCard(false);
  };

  const handleSearchOrClear = () => {
    if (showCard) {
      setSearchValue("");
      setDesignToFetch("");
      setShowCard(false);
      return;
    }

    if (!searchValue.trim()) return;

    const value = searchValue.trim();

    const exists = existingData?.some((obj) => obj.styleNumber?.toUpperCase() === value.toUpperCase());

    if (exists) {
      toast.error("Design already exists in table");
      return;
    }

    setDesignToFetch(value);
  };

  // const handleSelectDesign = (design) => {
  //   console.log("design====>>>",design)
  //   setSelectedDesign(true);
  //   // setShowCard(false);
  //   // setSearchValue("");
  // };

  const handleSelectDesign = (design) => {
    let uspSelectedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];

    const isAlreadyAdded = uspSelectedDesigns.some((item) => item.designNumber === design.designNumber);

    if (!isAlreadyAdded) {
      uspSelectedDesigns.push(design);
      sessionStorage.setItem("uspSelectedDesigns", JSON.stringify(uspSelectedDesigns));
    }

    setSelectedDesign(design);
    setShowCard(true);
  };

  const removeFromUsp = (designNumber) => {
    let uspSelectedDesigns = JSON.parse(sessionStorage.getItem("uspSelectedDesigns")) || [];
    uspSelectedDesigns = uspSelectedDesigns.filter((item) => item.designNumber !== designNumber);
    sessionStorage.setItem("uspSelectedDesigns", JSON.stringify(uspSelectedDesigns));

    // if (selectedDesign.designNumber == designNumber) {
    setSelectedDesign(null);
    // }
  };

  /* ---------- Save / Apply ---------- */

  const handleSave = async () => {
    handleSaveParent(selectedDesign?.designNumber);

    sessionStorage.removeItem("uspSelectedDesigns");

    if (!selectedDesign?.designNumber) return;
    handleCloseAddModal();
  };

  /* ---------- effects ---------- */

  useEffect(() => {
    if (data && designToFetch) {
      setShowCard(true);
    }
  }, [data, designToFetch]);

  /* ---------- render ---------- */

  return (
    <Modal open={open} onClose={handleCloseAddModal} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Box
        sx={{
          bgcolor: "#101010",
          borderRadius: "12px",
          width: "35vw",
          height: "60vh",
          display: "flex",
          flexDirection: "column",
          // border : "1px solid red"
        }}
      >
        <Box
          sx={{
            height: "100%",
            bgcolor: "#101010",
            display: "flex",
            flexDirection: "column",
            // border: "1px solid yellow",
            m: 3,
            mb: 0,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              // mb: 2,
            }}
          >
            <span style={modalTitleStyle}>Select Designs</span>

            <button style={closeBtnStyle} onClick={handleCloseAddModal}>
              <CloseIcon fontSize="inherit" />
            </button>
          </Box>

          {/* Search */}
          <Box sx={{ mt: "1.6vw", width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "#fff",
                borderRadius: "5px",
                boxShadow: "inset 0px 4px 20px 0px #00000040",
                height: "2.6vw",
                // width: "33.2vw",
                position: "relative",
              }}
            >
              <SearchIconPlaceHolder
                style={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "gray",
                  width: "1.4vw",
                  height: "1.4vw",
                  pointerEvents: "none",
                }}
              />
              <StyledInputBase
                placeholder="Search Design Number"
                sx={{
                  pl: "2.7vw",
                  // pr: "100px",
                  width: "100%",
                  height: "2.7vw",
                  fontFamily: "Karla",
                  fontSize: "1vw",
                  borderRadius: "5px",
                  background: "transparent",
                  color: "#000",
                }}
                value={searchValue}
                onChange={handleSearchInputChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchOrClear();
                  }
                }}
                inputProps={{ "aria-label": "search design number" }}
              />
              <IconButton
                disableRipple
                disableFocusRipple
                sx={{
                  position: "absolute",
                  right: 6,
                  top: "50%",
                  transform: "translateY(-50%)",
                  height: "2.1vw",
                  padding: "0.5vw !important",
                  width: "4.1vw",
                  borderRadius: "5px",
                  background: "#000",
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: "0.9vw",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={handleSearchOrClear}
              >
                {showCard ? "Clear" : "Search"}
              </IconButton>
            </Box>
          </Box>

          {/* Content */}

          {!showCard && !isLoading ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <img src={pickFile} alt="select" style={{ height: "14vh" }} />
              <span style={{ color: "#8b8b8b", fontSize: "12px" }}>Please, select Design</span>
            </Box>
          ) : (
            <Box sx={{ overflow: "auto", marginTop: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
              {isLoading ? (
                <div>
                  <ProductSkeleton />
                </div>
              ) : (
                <USPCard data={transformUspData(data)} showBtn={true} addToUsp={handleSelectDesign} removeFromUsp={removeFromUsp} />
              )}
            </Box>
          )}
        </Box>
        {/* Footer */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            //  border: "1px solid blue",
            background: "#191818",
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
            padding: "10px",
          }}
        >
          <Button
            disabled={!selectedDesign}
            sx={{
              bgcolor: selectedDesign ? "#50C878" : "#8B8B8B !important",
              color: "#000 !important",
              fontWeight: 500,
              fontFamily: "Poppins",
              "&:hover": {
                background: "#50C878 !important",
              },
            }}
            onClick={handleSave}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default SelectDesignModal;
